'use strict';

/**
 * Notification Service
 */
module.service('notificationService', [ 'Restangular', '$q', NotificationServiceFn ]);

function NotificationServiceFn(Restangular, $q) {

	/*
	 * ------------------------------------------------------------------------------
	 * SERVICE FUNCTIONS
	 * -------------------------------------------------------------------------------
	 */
	var notificationPath = '/notification';

	var ss = {};

	ss.search = function(filters) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(notificationPath).customGET(null, filters).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.areThereNewNotifications = function(lastId) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(notificationPath + '/arenewnotifications', lastId).get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.getUnreadNotifications = function() {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(notificationPath).customGET('unread').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.setNotificationViewed = function(id) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.one(notificationPath, id).customPUT(null, 'viewed').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	ss.setAllAsViewed = function() {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(notificationPath).customPUT(null, 'allAsViewed').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	return ss;
}
